import type { PiniaPlugin } from 'pinia'
import bindData from '@/utilities/bindData'

/**
 * サーバから受け取った ViewProps の global データを、store の生成時に context へ流し込む pinia プラグイン
 *
 * @param globalData ViewProps の global プロパティ（key 名は store の $id と一致させる）
 * @description
 *  pinia プラグインは各 store の setup 完了後、最初の useXxxStore() 呼び出し中に同期実行されるため、
 *  consumer の setup / onMounted 時点で context が埋まっている状態になる。
 *  store 内部の watcher（toast の id 付与、user の Datadog 連携）は setup で登録済みなので、ここでの代入で通常どおり発火する。
 *  global 側にデータが無い store（bookmark 等）や context を持たない store（screenLock）は何もしない。
 * @description
 *  プラグインは app.use(pinia) より前に生成された store には適用されないため、
 *  module top-level で useXxxStore() を呼ばないこと（_core/apiRequestManager.ts 参照）
 */
export default function hydrateFromViewProps(globalData: GlobalData): PiniaPlugin {
  return ({ store }) => {
    const data = globalData[store.$id as keyof GlobalData]
    if (data && 'context' in store) bindData(store.context as anyData, data)
  }
}
